import SpineWrapper from '@Core/Animation/SpineWrapper';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';
import { GameScene } from '..';

export class SpecialGamesSpine {
    public static readonly SPINE_KEY = 'specialGames';
    public static readonly SKIN_NAME = 'default';
    public spineWrapper: SpineWrapper;

    constructor(scene: GameScene) {
        this.spineWrapper = new SpineWrapper(
            scene,
            {
                x: scene.screen.width / 2,
                y: scene.screen.height / 2
            },
            { dataKey: SpecialGamesSpine.SPINE_KEY, skinName: SpecialGamesSpine.SKIN_NAME, manuallyScaleOnResize: false },
            true
        );
        this.spineWrapper.spine.zIndex = ELayeringOrder.SPECIAL_GAMES;
    }
}
